module.exports = __webpack_public_path__ + "assets/asset_plus.ce0b3519.svg";